import React from 'react';

import { trackClickEvent } from '@/components/account/ErcSchedule/utils';
import { GenInternalLink } from '@/components/generics';

import { LOCAL_STORAGE_KEYS } from '@/constants/localStorage';

import { CTA_NAMES } from '@/utils/rudderstack';

export interface OrderDetailsTableProps {
  label: string;
  addressId: string;
  subscriptionId?: string;
}

const EditAddressButton = ({
  label,
  addressId,
  subscriptionId,
}: OrderDetailsTableProps) => {
  const handleClick = () => {
    trackClickEvent(CTA_NAMES.EDIT_SHIPPING_ADDRESS);

    const redirectUrlPathname = window.location.pathname;

    const redirectUrlSearch = subscriptionId
      ? `?selected_subscription_uuid=${subscriptionId}`
      : '';

    window.localStorage.setItem(
      LOCAL_STORAGE_KEYS.editShippingAddressRedirectUrl,
      `${redirectUrlPathname}${redirectUrlSearch}`,
    );
  };

  return (
    <GenInternalLink
      href={`/account/early-reader-club/edit-shipping-address/${addressId}`}
      cta={label}
      onClick={handleClick}
    />
  );
};

export default EditAddressButton;
